export default "__VITE_ASSET__fde0328d__"